/**
 * Created by leo108 on 2018/6/15.
 */
import { markRaw } from 'vue'
import $ from 'jquery'
import { is_unlimited_quota } from '../../utils'
import MultipartVideoUploader from './multipart-video-uploader'
import constants from '@/generated/constants.js'

export default {
  data () {
    return {
      videoUploader: null,

      uploadProgress: null
    }
  },
  methods: {
    pickFile (ref, uploading) {
      if (!uploading) {
        $(this.$refs[ref]).trigger('click')
      }
    },
    async uploadVideo (file, disk) {
      this.videoUploader = markRaw(new MultipartVideoUploader(file.name, {
        chuckSize: 20 * 1024 * 1024,
        contentType: file.type,
        disk
      }))

      this.videoUploader.addEventListener('progress', e => {
        if (e.detail.progress > this.uploadProgress) {
          this.uploadProgress = e.detail.progress
        }
      })

      await this.videoUploader.upload(file)
      await this.videoUploader.complete(true)

      return this.videoUploader.key
    },
    preCheckUploadingFile (file, maxGb = -1) {
      if (!file) {
        return false
      }

      if (constants.GLOBAL.VIDEO_EXTENSION_ALLOW_LIST.indexOf('.' + file.name.split('.').pop().toLowerCase()) < 0) {
        window.SwalTimer.fire({
          icon: 'error',
          title: 'This file is not a video.'
        })
        return false
      }

      if (file.size === 0) {
        window.SwalTimer.fire({
          icon: 'error',
          title: 'This file size is 0.'
        })
        return false
      }

      if (!is_unlimited_quota(maxGb) && file.size > maxGb * 1024 * 1024 * 1024) {
        const limitation = maxGb >= 1 ? `${maxGb}GB` : `${(maxGb * 1000).toFixed(2)}MB`

        window.SwalTimer.fire({
          icon: 'error',
          title: `This file exceeds our limit of ${limitation}. Please try again.`
        })
        return false
      }

      return true
    }
  }
}
